module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPGNpcmNsZSBjeD0iOS42NzU4OCIgY3k9IjEwLjI0IiByPSI4LjcxNDA1IiBzdHJva2U9IiNBQUFBQUEiIHN0cm9rZS13aWR0aD0iMS40NTIzNCIvPg0KPHBhdGggZD0iTTkuMDg1ODggNi4xMDk4NlYxMS40MkwxMi4wMzU5IDE0LjM3MDEiIHN0cm9rZT0iI0FBQUFBQSIgc3Ryb2tlLXdpZHRoPSIxLjQ1MjM0Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_time.svg
// module id = 3GRy
// module chunks = 1